import React from "react";
import RecentItem from "../recent-summary/parts/RecentItem";
import RecentSummary from "../recent-summary/RecentSummary";
import iconTxt from "../../assets/images/dummy/icon-txt.png";
import { IconOpen } from "../../icons/Icon";
import { CATALOGS_CATEGORY } from "../../constants/categories";

const title = "Catálogos recientes";
const badgeColor = "#8E59FF";

const RecentCatalogs = ({ catalogs, download, downloading }) => {
  return (
    <RecentSummary
      title={title}
      badgeColor={badgeColor}
      noData={!catalogs.length}
    >
      {catalogs.map((catalog) => (
        <RecentItem
          key={catalog.uuid}
          icon={iconTxt}
          primaryInfo={catalog.items.url}
          controlIcon={<IconOpen color="#33383F" />}
          control={() => { }}
          loading={downloading == catalog.uuid}
          link={catalog.items.url}
        />
      ))}
    </RecentSummary>
  );
};

export default RecentCatalogs;
